<div class="w-2/3 overflow-hidden" [formGroup]="form()" hlmFieldGroup>
  <div hlmField>
    <label hlmFieldLabel for="select-secteurs">Secteurs d'activité</label>
    <brn-select
      class="inline-block"
      id="select-secteurs"
      [compareWith]="compareWithId"
      placeholder="Sélectionner les secteurs d'activité"
      multiple
      formControlName="secteursActivite"
    >
      <hlm-select-trigger>
        <hlm-select-value />
      </hlm-select-trigger>
      <hlm-select-content class="w-max">
        @for (item of secteur()?.sousCaracteristiques | trierPar: 'nom'; track $index) {
          <hlm-option [value]="item">{{ item.nom }}</hlm-option>
        }
      </hlm-select-content>
    </brn-select>
  </div>
  <div hlmField>
    <label hlmFieldLabel for="emplois-possibles">Emplois possibles</label>
    <input id="emplois-possibles" hlmInput type="text" formControlName="emploisPossibles" />
    <p hlmFieldDescription>Si vide, libre au choix de l'apprenant.</p>
  </div>
  <div hlmField>
    <label hlmFieldLabel for="competences-transverses">Compétences transverses</label>
    <input id="competences-transverses" hlmInput type="text" formControlName="competencesTransverses" />
    <p hlmFieldDescription>Si vide, libre au choix de l'apprenant.</p>
  </div>
</div>
